import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function ClaimHelp({ theme, ...props }) {
  return (
    <svg
      width="28"
      height="26"
      xmlns="http://www.w3.org/2000/svg"
      className={cx(theme.container, theme[props.svg], props.className)}
    >
      <g fill="none" fillRule="evenodd" className={theme.stroke}>
        <path
          fill="#FFF"
          d="M26.444 1.904H1.556v17.215h3.318v4.977l4.874-4.977h16.696z"
        />
        <path fill="#DE2527" d="M21.259 1.904h5.185V19.12h-5.185z" />
        <path
          stroke="#4A4A4A"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M26.444 1.904H1.556v17.215h3.318v4.977l4.874-4.977h16.696z"
        />
      </g>
    </svg>
  )
}

ClaimHelp.propTypes = {
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
}
